// ag-grid-enterprise v19.1.4
"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ag_grid_community_1 = require("ag-grid-community");

var StatusBarService =
/** @class */
function () {
  function StatusBarService() {
    this.allComponents = {};
  }

  StatusBarService.prototype.registerStatusPanel = function (key, component) {
    this.allComponents[key] = component;
  };

  StatusBarService.prototype.getStatusPanel = function (key) {
    return this.allComponents[key];
  };

  StatusBarService = __decorate([ag_grid_community_1.Bean('statusBarService'), __metadata("design:paramtypes", [])], StatusBarService);
  return StatusBarService;
}();

exports.StatusBarService = StatusBarService;